import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetFileSizes } from '../../api/Files';

import { showModal } from '../../actions';

import AdminFileSizesHeader from '../../components/Admin/FileSizes/Header';
import AdminFileSizesList from '../../components/Admin/FileSizes/List';
import AdminFileSizesFooter from '../../components/Admin/FileSizes/Footer';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';

import Loading from '../../components/Loading';
import ErrorBoundary from '../../components/ErrorBoundary';
import HelpIcon from '../../components/HelpIcon';
import EmptyFileSizes from '../EmptyContainers/FileSizes';

class AdminFileSizes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sizes: [],
      sizesTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'name',
      order: 'asc',
      loading: true,
      timestamp: new Date().toISOString(),
    };

    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleAddSize = this.handleAddSize.bind(this);
    this.loadFileSizes = this.loadFileSizes.bind(this);
    this.updateSizeOnList = this.updateSizeOnList.bind(this);
    this.deleteSizeFromList = this.deleteSizeFromList.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      () => this.loadFileSizes(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { orderBy, order } = this.state;

    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['page', 'perPage', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      () => this.loadFileSizes(),
      { orderBy: 'name', order: 'asc', perPage: getUserSetting('admin_per_page') || 20 },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }
  }

  loadFileSizes(silent = false) {
    const {
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    if (!silent) {
      this.setState({ loading: true });
    }

    APIgetFileSizes({
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          sizes: data.data,
          sizesTotal: data.meta.total,
        });
      }
    });
  }

  updateSizeOnList(size) {
    const { sizes } = this.state;

    const idx = sizes.findIndex(s => (s.id === size.id));
    if (idx >= 0) {
      sizes[idx] = size;
      this.setState({
        sizes,
        timestamp: new Date().toISOString(),
      });
    }
  }

  deleteSizeFromList(size) {
    this.setState(prevState => ({
      sizes: prevState.sizes.filter(s => (s.id !== size.id)),
    }));
    this.loadFileSizes(true);
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ page: 1, perPage }, history);

    this.setState({ page: 1, perPage });
  }

  handleAddSize(e) {
    const { dispatch } = this.props;

    if (e) {
      e.preventDefault();
    }

    dispatch(showModal('FileSizeEditModal', {
      className: 'modal-new-size',
      afterCreateSize: () => {
        this.loadFileSizes(true);
      },
    }));
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      page,
      perPage,
      sizesTotal,
      loading,
    } = this.state;

    return (
      <>
        <Row>
          <Col>
            <AdminFileSizesHeader
              sizesTotal={sizesTotal}
              sizesVisible={getVisibleItemsText(page, perPage, sizesTotal)}
              loading={loading}
              handleAddSize={this.handleAddSize}
            />
          </Col>
        </Row>
        <p>
          {intl.formatMessage({ defaultMessage: 'Create and manage your file sizes. File sizes allow you to provide additional file sizes for your users to download based on need.' })}
          <HelpIcon
            id="help-file-sizes"
            url="https://help.stockpress.co/en/articles/5937873-add-multiple-file-sizes-for-downloads"
          />
        </p>
        {loading ? (
          <Loading />
        ) : (
          <>
            <ErrorBoundary>
              <AdminFileSizesList
                {...this.state}
                loadSizes={this.loadSizes}
                handleChangeOrder={this.handleChangeOrder}
                updateSizeOnList={this.updateSizeOnList}
                deleteSizeFromList={this.deleteSizeFromList}
              />
            </ErrorBoundary>
            <ErrorBoundary>
              <AdminFileSizesFooter
                {...this.state}
                handleChangePage={this.handleChangePage}
                handleChangePerPage={this.handleChangePerPage}
              />
            </ErrorBoundary>
            {sizesTotal === 0 && (
            <EmptyFileSizes handleNewItem={this.handleAddSize} padded={true} />
            )}
          </>
        )}
      </>
    );
  }
}

AdminFileSizes.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(connect()(injectIntl(AdminFileSizes)));
